import { render, staticRenderFns } from "./AccessRequirement.vue?vue&type=template&id=fb2fb0ee&"
import script from "./AccessRequirement.vue?vue&type=script&lang=js&"
export * from "./AccessRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports